import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { LayoutDashboard, History, Briefcase, MoreHorizontal, BarChart2 } from "lucide-react"
import { cn } from "@/lib/utils"
import { MobileDrawer } from "./MobileDrawer"
import { useTranslation } from "react-i18next"

export function MobileNav() {
    const { t } = useTranslation()
    const location = useLocation()
    const [drawerOpen, setDrawerOpen] = useState(false)

    const CORE_NAV_ITEMS = [
        { icon: LayoutDashboard, label: t('sidebar.home'), href: "/" },
        { icon: Briefcase, label: t('sidebar.projects'), href: "/projects" },
        { icon: History, label: t('sidebar.history'), href: "/history" },
        { icon: BarChart2, label: t('sidebar.reports'), href: "/reports" },
    ]

    // Secondary routes: if user is on one of these, highlight "Más"
    const secondaryRoutes = ["/clients", "/quotes", "/team", "/approvals", "/billing", "/ai-assistant", "/settings", "/help"]
    const isMoreActive = secondaryRoutes.some(r => location.pathname.startsWith(r))

    return (
        <>
            <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-card/90 backdrop-blur-xl border-t border-border/50 px-2 py-2 flex justify-around items-center" style={{ paddingBottom: 'calc(0.5rem + env(safe-area-inset-bottom, 0px))' }}>
                {CORE_NAV_ITEMS.map((item) => {
                    const isActive = location.pathname === item.href

                    return (
                        <Link
                            key={item.href}
                            to={item.href}
                            className={cn(
                                "flex flex-col items-center justify-center px-3 py-1.5 rounded-xl transition-all duration-200 min-w-[56px]",
                                isActive
                                    ? "text-primary bg-primary/10"
                                    : "text-muted-foreground hover:text-foreground"
                            )}
                            title={item.label}
                        >
                            <item.icon className={cn("h-5 w-5", isActive && "text-primary")} />
                            <span className="text-[10px] mt-1 font-medium">{item.label}</span>
                        </Link>
                    )
                })}

                {/* "Más" button — opens the drawer */}
                <button
                    onClick={() => setDrawerOpen(true)}
                    className={cn(
                        "flex flex-col items-center justify-center px-3 py-1.5 rounded-xl transition-all duration-200 min-w-[56px]",
                        isMoreActive || drawerOpen
                            ? "text-primary bg-primary/10"
                            : "text-muted-foreground hover:text-foreground"
                    )}
                    title={t('common.more')}
                >
                    <MoreHorizontal className={cn("h-5 w-5", (isMoreActive || drawerOpen) && "text-primary")} />
                    <span className="text-[10px] mt-1 font-medium">{t('common.more')}</span>
                </button>
            </nav>

            <MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
        </>
    )
}
